import axiosConfig from "./axiosConfig";

const BASE = "/advertising/admin";

export const listCampaigns = (params = {}) =>
  axiosConfig.get(`${BASE}/campaigns/`, { params });

export const getCampaign = (id) =>
  axiosConfig.get(`${BASE}/campaigns/${id}/`);

export const createCampaign = (data) =>
  axiosConfig.post(`${BASE}/campaigns/`, data);

export const updateCampaign = (id, data) =>
  axiosConfig.patch(`${BASE}/campaigns/${id}/`, data);

export const deleteCampaign = (id) =>
  axiosConfig.delete(`${BASE}/campaigns/${id}/`);

export const activateCampaign = (id) =>
  axiosConfig.post(`${BASE}/campaigns/${id}/activate/`);

export const pauseCampaign = (id) =>
  axiosConfig.post(`${BASE}/campaigns/${id}/pause/`);

export const resumeCampaign = (id) =>
  axiosConfig.post(`${BASE}/campaigns/${id}/resume/`);

export const getTargeting = (id) =>
  axiosConfig.get(`${BASE}/campaigns/${id}/targeting/`);

export const updateTargeting = (id, data) =>
  axiosConfig.put(`${BASE}/campaigns/${id}/targeting/`, data);

export const listAdvertisements = (campaignId) =>
  axiosConfig.get(`${BASE}/campaigns/${campaignId}/advertisements/`);

export const createAdvertisement = (campaignId, data) =>
  axiosConfig.post(`${BASE}/campaigns/${campaignId}/advertisements/`, data);

export const getAdvertisement = (uuid) =>
  axiosConfig.get(`${BASE}/advertisements/${uuid}/`);

export const updateAdvertisement = (uuid, data) =>
  axiosConfig.patch(`${BASE}/advertisements/${uuid}/`, data);

export const deleteAdvertisement = (uuid) =>
  axiosConfig.delete(`${BASE}/advertisements/${uuid}/`);

export const uploadVideo = (uuid, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("video", file);
  return axiosConfig.post(`${BASE}/advertisements/${uuid}/upload-video/`, formData, {
    onUploadProgress,
  });
};

export const getAnalytics = (id) =>
  axiosConfig.get(`${BASE}/campaigns/${id}/analytics/`);

export const exportAnalytics = async (id) => {
  const response = await axiosConfig.get(`${BASE}/campaigns/${id}/analytics/export/`, {
    responseType: "blob",
  });
  return response;
};

export const fetchStates = () =>
  axiosConfig.get("/masters/states/?page_size=1000");

export const fetchCities = (stateId) =>
  axiosConfig.get(`/masters/cities/?page_size=1000${stateId ? `&state=${stateId}` : ""}`);

export const fetchCrafts = () =>
  axiosConfig.get("/masters/role-24-frames/?page_size=1000");
